import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  AiOutlineHome,
  AiOutlineUser,
  AiOutlineFile,
  AiOutlineProject,
  AiOutlineRocket,
  AiOutlineMail,
  AiOutlineTool,
  AiOutlineLink,
  AiOutlineDollarCircle,
  AiOutlineRead,
} from "react-icons/ai";
import { HiOutlineBriefcase } from "react-icons/hi";
import "./TopBar.css";

const TopBar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  const handleClick = () => {
    toggleMenu();
    scrollToTop();
  };

  return (
    <div className="topbar">
      <div className="topbar-header">
        <Link to="/" className="logo" onClick={scrollToTop}>
          {/* <h2 className="sidebardTitle">Danial's website</h2> */}
          {/* <h2 className="sidebardTitle">ダニアル・コア</h2> */}
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <img
              // src="/The Guardian.png"
              src="/Gemini_Generated_Image_mnryikmnryikmnry-removebg-preview-1.png"
              alt="Guardian Icon"
              style={{ height: "32px", filter: "brightness(0) invert(1)" }}
            />
            <h2 className="sidebardTitle">𐎠𐏃𐎢𐎼𐎶</h2>
          </div>
        </Link>
        <button className="menu-toggle" onClick={toggleMenu}>
          <span className="menu-icon"></span>
        </button>
      </div>

      <nav className={`topbar-nav ${isMenuOpen ? "open" : ""}`}>
        <Link to="/" className="sidebar-link" onClick={handleClick}>
          <div className="section">
            <AiOutlineHome size={20} /> Home
          </div>
        </Link>

        {/* <Link to="/about-me" className="sidebar-link" onClick={toggleMenu}>
          <div className="section">
            <AiOutlineUser size={20} /> About Me
          </div>
        </Link> */}

        {/* <Link
          to="/freelance"
          className="sidebar-link"
          title="Freelance Services"
          onClick={handleClick}
        >
          <div className="section">
            <HiOutlineBriefcase size={20} /> Freelance
          </div>
        </Link> */}

        {/* <Link to="/portfolio" className="sidebar-link" onClick={handleClick}>
          <div className="section">
            <AiOutlineProject size={20} /> Portfolio
          </div>
        </Link> */}

        {/* <Link to="/startups" className="sidebar-link" onClick={handleClick}>
          <div className="section">
            <AiOutlineRocket size={20} /> Startups
          </div>
        </Link> */}

        <Link to="/resume" className="sidebar-link" onClick={handleClick}>
          <div className="section">
            <AiOutlineFile size={20} /> Resume
          </div>
        </Link>

        {/* <Link to="/skills" className="sidebar-link" title="Skills">
          <div className="section">
            <AiOutlineTool size={20} /> Skills
          </div>
        </Link> */}

        <a
          href="https://ghost.danials.org/"
          className="sidebar-link"
          title="Blog"
          onClick={handleClick}
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="section">
            <AiOutlineRead size={20} /> Blog
          </div>
        </a>

        <Link
          to="/links"
          className="sidebar-link"
          title="Links"
          onClick={handleClick}
        >
          <div className="section">
            <AiOutlineLink size={20} /> Links
          </div>
        </Link>

        <Link to="/contact" className="sidebar-link" onClick={handleClick}>
          <div className="section">
            <AiOutlineMail size={20} /> Contact
          </div>
        </Link>
      </nav>
    </div>
  );
};

export default TopBar;
